import { get } from './require'

const cmsApi = {
  GetInquiryFlow: (params) => get('https://bm.lianouyiyuan.com/Flights/GetInquiryFlow', params, 'cms')
}

export default cmsApi
